export default __webpack_public_path__ + "static/media/hht2_sitcom_01.8ce21451.png";